import { createFileRoute } from "@tanstack/react-router"
import { get } from "../../../../../../typed-client/get"
import { lazyImportRouteComponent } from "../../../../../../utils/lazyImportRouteComponent"

type Tab = "start" | "casts" | "jobSteps"

export const Route = createFileRoute("/app/art/productions/$id/$roleId/")({
  component: lazyImportRouteComponent(
    () => import("./-components/RoleDetails"),
    "RoleDetails"
  ),
  validateSearch: (search: { tab: Tab; seasonFilter?: string }) => ({
    tab: search.tab || "start",
    seasonFilter: search.seasonFilter,
  }),
  beforeLoad: async (context) => {
    const role = await get("/api/Role/GetRole", {
      roleId: parseInt(context.params.roleId),
    })

    return { getTitle: () => role?.name }
  },
})
